import { cn } from '../../../utils/cn'

const iconBase = 'material-symbols-rounded leading-none select-none'
/* Quoted rather than bare JSX text so `bin/subset-material-symbols.py` harvests
   the names into every app's font subset. */
const glyph = {
  unchecked: 'check_box_outline_blank',
  checked: 'check_box',
  indeterminate: 'indeterminate_check_box'
} as const
const iconFilled = "[font-variation-settings:'FILL'_1]"

export function DefaultCheckboxIcons() {
  return (
    <>
      <span
        className={cn(
          iconBase,
          'group-data-[checked]:hidden group-data-[indeterminate]:hidden'
        )}
      >
        {glyph.unchecked}
      </span>
      <span
        className={cn(
          iconBase,
          iconFilled,
          'hidden group-data-[checked]:inline-flex group-data-[indeterminate]:hidden'
        )}
      >
        {glyph.checked}
      </span>
      <span
        className={cn(
          iconBase,
          iconFilled,
          'hidden group-data-[indeterminate]:inline-flex'
        )}
      >
        {glyph.indeterminate}
      </span>
    </>
  )
}
